import React from 'react';
import { Switch, Route, } from 'react-router-dom';
import { CLAIMING_ROUTE } from './constants';
import { Claiming } from './views';
export var RootRoutes = function () {
    return (React.createElement(Switch, null,
        React.createElement(Route, { path: CLAIMING_ROUTE, component: Claiming })));
};
